/* Proconex Lévesque — comportements du thème
   Aucune dépendance externe. Tout est délégué et défensif. */
(function () {
  'use strict';

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Mouvement réduit ≠ zéro mouvement : les effets liés au défilement gardent le récit mais avec une
     amplitude réduite (RM_AMP) ; seuls les mouvements automatiques décoratifs sont coupés. */
  var RM_AMP = RM ? 0.3 : 1;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var ease  = function (t) { return 1 - Math.pow(1 - t, 3); };

  /* ---------------------------------------------------------------- loader */
  /* Les entrées du hero (titre, sur-titre, boutons) attendent la fin de l'écran de chargement : sans cela elles
     se jouaient derrière lui (1,2 à 2,5 s) et le titre paraissait « mort » à l'arrivée sur la page. */
  var heroGo = function () { document.documentElement.classList.add('lo-done'); };
  function loader() {
    var el = $('#loader');
    if (!el) { heroGo(); return; }
    try {
      if (sessionStorage.getItem('px:vu')) { el.remove(); heroGo(); return; }
      sessionStorage.setItem('px:vu', '1');
    } catch (err) {}
    var done = false;
    /* L'intro (balayage du logo 1,27 s, barre 1,5 s) doit pouvoir se lire : sur cache chaud la page est
       prête en ~0,4 s et l'écran ne durait qu'un éclair. Plancher = durée du balayage du logo, une fois
       par session ; jamais au-delà, et le plafond de 2,5 s reste. */
    var MIN_SHOW = 1200;
    var hideNow = function () { if (done) return; done = true; el.classList.add('is-done'); el.setAttribute('aria-hidden', 'true'); heroGo(); };
    /* Le plancher se compte depuis le DÉBUT DE LA NAVIGATION, pas depuis l'exécution du script :
       sur un téléphone bridé, proconex.js arrive vers 2,2 s et le plancher s'ajoutait à ce retard,
       retardant d'autant la première peinture utile (le hero n'entre qu'après « lo-done »). */
    var hide = function () { var left = MIN_SHOW - performance.now(); if (left > 0) setTimeout(hideNow, left); else hideNow(); };
    /* Mouvement réduit : marque statique (CSS retire balayage, barre et photos) et aucun plancher —
       l'écran disparaît dès que le document est utilisable, jamais prolongé artificiellement. */
    if (RM) MIN_SHOW = 0;
    // au-delà du plancher de l'intro, aucun délai : on masque dès que le contenu est utilisable — DOM
    // prêt et polices chargées (pour éviter un saut de fonte derrière l'écran) — sans attendre la dernière image.
    /* Les fontes ne retiennent plus l'écran au-delà de 500 ms : elles sont chargées en
       « display:swap », le texte s'affiche donc de toute façon, et attendre le réseau de Google
       repoussait la première peinture utile de plusieurs secondes sur connexion lente. */
    var fontsReady = (document.fonts && document.fonts.ready)
      ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 500); })])
      : Promise.resolve();
    var domReady = new Promise(function (res) { if (document.readyState !== 'loading') res(); else document.addEventListener('DOMContentLoaded', res, { once: true }); });
    Promise.all([domReady, fontsReady]).then(function () { requestAnimationFrame(hide); }, function () { requestAnimationFrame(hide); });
    window.addEventListener('load', function () { requestAnimationFrame(hide); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) hideNow(); }); // retour arrière (bfcache) : jamais de loader figé
    setTimeout(hideNow, 2500); // filet de sécurité
  }

  /* ---------------------------------------------------------------- entête */
  function header() {
    var hdr = $('.hdr'), mega = $('.mega'), scrim = $('.scrim'), btn = $('.menu-btn');
    if (!hdr) return;

    var solid = false;
    var onScroll = function () {
      var want = window.scrollY > 24;
      if (want !== solid) { solid = want; hdr.classList.toggle('is-solid', want); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    if (!btn || !mega) return;
    var open = false;
    /* Les images du panneau ne sont téléchargées qu'à la première ouverture : elles ne pèsent plus
       sur le premier rendu de la page. */
    var fillMenuMedia = function () {
      $$('img[data-menu-src]', mega).forEach(function (img) {
        if (img.dataset.menuSrcset) { img.srcset = img.dataset.menuSrcset; img.removeAttribute('data-menu-srcset'); }
        img.src = img.dataset.menuSrc; img.removeAttribute('data-menu-src');
      });
    };
    var set = function (v) {
      if (v) fillMenuMedia();
      open = v;
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
      mega.classList.toggle('is-open', v);
      if (scrim) scrim.classList.toggle('is-open', v);
      document.documentElement.style.overflow = v ? 'hidden' : '';
      document.documentElement.classList.toggle('menu-open', v);
    };
    // retour arrière (bfcache) ou navigation : jamais de menu figé ouvert ni de défilement bloqué
    window.addEventListener('pageshow', function () { if (open) set(false); document.documentElement.style.overflow = ''; });
    var lastFocus = null;
    var focusables = function () { return $$('a[href],button,select,input,textarea,[tabindex]:not([tabindex="-1"])', mega).filter(function (n) { return n.offsetParent !== null; }); };
    /* Ouverture au clavier (Entrée/Espace sur le bouton) : le focus va au premier lien. Ouverture au doigt ou à
       la souris : le focus va au panneau lui-même (tabindex -1, sans contour) — sinon « Accueil » recevait un
       contour de focus jaune mal dimensionné dès l'ouverture du menu mobile. Le piège de focus et Échap restent. */
    var viaKeyboard = false;
    btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') viaKeyboard = true; });
    btn.addEventListener('pointerdown', function () { viaKeyboard = false; }, { passive: true });
    if (!mega.hasAttribute('tabindex')) mega.setAttribute('tabindex', '-1');
    var setA = function (v) {
      if (v) {
        // Safari ne donne pas le focus à un bouton cliqué : on retombe sur le bouton du menu lui-même
        lastFocus = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : btn;
        set(v);
        // le panneau est encore visibility:hidden à cet instant (transition) : on attend qu'il soit affiché
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (!open) return;
          var target = viaKeyboard ? focusables()[0] : mega;
          if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
          viaKeyboard = false;
        }); });
      } else {
        set(v);
        var back = (lastFocus && lastFocus.focus) ? lastFocus : btn;
        try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
      }
    };
    btn.addEventListener('click', function (e) { e.stopPropagation(); setA(!open); });
    if (scrim) scrim.addEventListener('click', function () { setA(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { setA(false); return; }
      if (e.key !== 'Tab' || !open) return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); btn.focus(); }
    });
    mega.addEventListener('click', function (e) { if (e.target.closest('a')) setA(false); });
  }

  /* -------------------------------------------------- révélation au scroll */
  function reveal() {
    var items = $$('[data-rv]');
    if (!items.length) return;
    document.documentElement.classList.add('rv-ready');
    /* Un observateur seul n'a aucun chemin de récupération : un bloc qui traverse l'écran sans être
       échantillonné « en intersection » (flick rapide, saut d'ancre, onglet caché pendant le
       défilement, retour bfcache) reste invisible pour de bon. L'observateur garde l'entrée en
       douceur ; un filet de sécurité révèle tout bloc déjà entré ou déjà dépassé, sans délai.
       Le filet ne dépend ni de requestAnimationFrame ni d'un drapeau booléen (un rAF suspendu dans
       un document caché laisserait le drapeau levé et ignorerait tous les défilements suivants) :
       il est cadencé par un simple délai et relancé au retour de visibilité. */
    var pending = items.slice();
    var show = function (n, immediate) {
      n.style.transitionDelay = immediate ? '0s' : ((parseFloat(n.getAttribute('data-rv')) || 0) + 's');
      n.classList.add('is-in');
    };
    var forget = function (n) { var i = pending.indexOf(n); if (i >= 0) pending.splice(i, 1); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = en.target;
        show(n, false); forget(n); io.unobserve(n);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
    items.forEach(function (n) { io.observe(n); });
    var timer = 0;
    var sweep = function () {
      timer = 0;
      if (!pending.length) return;
      var vh = window.innerHeight || 800;
      for (var i = pending.length - 1; i >= 0; i--) {
        var n = pending[i], r = n.getBoundingClientRect();
        if (r.top < vh * 0.9) { show(n, r.bottom < 0); pending.splice(i, 1); io.unobserve(n); } // entré ou dépassé
      }
    };
    var ask = function () { if (!timer) timer = setTimeout(sweep, 60); };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    window.addEventListener('pageshow', ask);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) ask(); });
    setTimeout(ask, 900); // ce qui est déjà dans l'écran au chargement
  }

  /* ------------------------------------------------------- compteurs animés */
  function counters() {
    var band = $('.statsband');
    var nodes = $$('[data-count]');
    var rbq = $('[data-rbq-roll]');
    if (!band && !nodes.length && !rbq) return;

    function genericCount(n) {
      var target = parseFloat(n.getAttribute('data-count')) || 0;
      var pre = n.getAttribute('data-prefix') || '';
      var suf = n.getAttribute('data-suffix') || '';
      var dur = 950, t0 = performance.now();
      n.textContent = pre + '0' + suf;
      var step = function (now) {
        var p = clamp((now - t0) / dur, 0, 1);
        n.textContent = pre + Math.round(target * ease(p)) + suf;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    function runBand() {
      if (!band || band.dataset.rolled === '1') return;
      band.dataset.rolled = '1';
      var nums = $$('[data-count]', band);
      if (RM) {
        nums.forEach(function(n){ n.textContent=(n.getAttribute('data-prefix')||'')+n.getAttribute('data-count')+(n.getAttribute('data-suffix')||''); });
        if (rbq) rbq.textContent = rbq.getAttribute('data-rbq-roll') || rbq.textContent;
        return;
      }
      /* Maquette: petit effet “loto” qui ralentit avant de tomber sur la vraie valeur. */
      var seqs = [
        ['1','3','0','2','1','3','0','2','1','3'],
        ['3','5','1','6','2','4','7','5','6','5']
      ];
      nums.slice(0,2).forEach(function(n, idx){
        var target=n.getAttribute('data-count')||'0', suf=n.getAttribute('data-suffix')||'';
        var seq=seqs[idx]||[], i=0;
        function tick(){
          n.textContent=(seq[i] != null ? seq[i] : target)+suf; i++;
          if(i<seq.length) setTimeout(tick,46+i*i*3.2);
          else n.textContent=target+suf;
        }
        tick();
      });
      nums.slice(2).forEach(genericCount);
      if (rbq) {
        var target = rbq.getAttribute('data-rbq-roll') || '5846-4108-01';
        var pos=[]; for(var k=0;k<target.length;k++) if(target[k] !== '-') pos.push(k);
        var locked=0;
        function roll(){
          var out=target.split('');
          for(var j=locked;j<pos.length;j++) out[pos[j]]=String(Math.floor(Math.random()*10));
          rbq.textContent=out.join('');
          if(locked<pos.length){locked++;setTimeout(roll,40+locked*locked*1.9);} else rbq.textContent=target;
        }
        roll();
      }
    }

    if (band) {
      if (RM) return runBand();
      var ioBand = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(!en.isIntersecting)return; runBand(); ioBand.disconnect(); });
      }, { rootMargin:'0px 0px -10% 0px', threshold:0.18 });
      ioBand.observe(band);
      /* filet : si l'observateur n'a pas échantillonné la bande (défilement rapide, onglet caché), un
         contrôle cadencé au défilement lance l'effet dès qu'elle est réellement à l'écran, une seule fois */
      var bt = 0;
      var bandCheck = function () {
        bt = 0;
        if (band.dataset.rolled === '1') return;
        var r = band.getBoundingClientRect(), vh = window.innerHeight || 800;
        if (r.top < vh * 0.9 && r.bottom > vh * 0.1) { runBand(); ioBand.disconnect(); }
      };
      var bandAsk = function () { if (!bt) bt = setTimeout(bandCheck, 80); };
      window.addEventListener('scroll', bandAsk, { passive: true });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) bandAsk(); });
      setTimeout(bandAsk, 900);
    }

    /* Autres compteurs éventuels hors de la bande. */
    var others = nodes.filter(function(n){ return !band || !band.contains(n); });
    if (!others.length) return;
    if (RM) { others.forEach(function(n){n.textContent=(n.getAttribute('data-prefix')||'')+n.getAttribute('data-count')+(n.getAttribute('data-suffix')||'');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(!en.isIntersecting)return; io.unobserve(en.target); genericCount(en.target); });
    }, {threshold:0.3});
    others.forEach(function(n){io.observe(n);});
  }

  /* ----------------------------------------------------------- parallaxe */
  function magnetic() {
    if (RM || !(window.matchMedia && window.matchMedia('(pointer:fine)').matches)) return;
    $$('[data-magnetic]').forEach(function (el) {
      var raf = 0, px = 0, py = 0;
      function draw() {
        raf = 0;
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var dx = (px - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (py - (r.top + r.height / 2)) / (r.height / 2);
        dx = clamp(dx, -1, 1); dy = clamp(dy, -1, 1);
        el.style.transform = 'translate3d(' + (dx * 9).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px,0) scale(1.03)';
      }
      el.addEventListener('pointermove', function (e) {
        px = e.clientX; py = e.clientY;
        if (!raf) raf = requestAnimationFrame(draw);
      });
      el.addEventListener('pointerleave', function () {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        el.style.transform = '';
      });
    });
  }

function heroScroll() {
  var m = document.getElementById('heromedia');
  if (!m) return;
  /* Téléphone : l'image du hero glisse aussi, à amplitude réduite et sans zoom (profondeur douce, pas de déplacement agressif). */
  var MOB = window.innerWidth <= 760;
  var pend = false;
  var apply = function () {
    pend = false;
    var y = window.scrollY || 0, vh = window.innerHeight || 800;
    if (y > vh * 1.4) return;
    var PK = MOB ? 0.5 : Math.max(0.42, Math.min(1, window.innerWidth / 1440));
    m.style.transform = 'translate3d(0,' + (y * 0.3 * PK * RM_AMP).toFixed(1) + 'px,0) scale(' + (1.06 + (RM || MOB ? 0 : Math.min(y, 900) * 0.00009)).toFixed(4) + ')';
  };
  window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(apply); } }, { passive: true });
  window.addEventListener('resize', function () { if (!pend) { pend = true; requestAnimationFrame(apply); } }, { passive: true });
  apply();
}

function svPromise() {
  var root = document.querySelector('[data-svp]');
  if (!root) return;
  var dataEl = root.querySelector('[data-svp-data]');
  var steps = [];
  try { steps = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { steps = []; }
  var cards = $$('[data-svp-step]', root);
  var shot = root.querySelector('[data-svp-shot]');
  var nEl = root.querySelector('[data-svp-n]'), tEl = root.querySelector('[data-svp-title]');
  var lEl = root.querySelector('[data-svp-long]'), gEl = root.querySelector('[data-svp-tags]');
  var detail = root.querySelector('[data-svp-detail]');
  /* État initial : toutes les étapes fermées (aucune carte pressée, panneau détail masqué). Le client
     ouvre une étape volontairement ; un second clic sur l'étape ouverte la referme. */
  var sel = function (i) {
    var d = steps[i];
    if (!d) {
      cards.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      if (detail) detail.hidden = true;
      return;
    }
    if (detail) detail.hidden = false;
    cards.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    if (nEl) nEl.textContent = (i < 9 ? '0' : '') + (i + 1);
    if (tEl) tEl.textContent = d.t || '';
    if (lEl) lEl.textContent = d.long || '';
    if (gEl) {
      gEl.textContent = '';
      (d.tags || []).forEach(function (tg) { if (!tg || !String(tg).trim()) return; var s = document.createElement('span'); s.textContent = String(tg).trim(); gEl.appendChild(s); });
    }
    if (shot && d.img) shot.style.backgroundImage = "url('" + d.img + "')";
  };
  cards.forEach(function (c, i) {
    c.addEventListener('click', function () { sel(c.getAttribute('aria-pressed') === 'true' ? -1 : i); });
    c.addEventListener('mouseenter', function () { if (window.matchMedia && window.matchMedia('(pointer:fine)').matches) sel(i); });
  });
  sel(-1);
  var gh = root.querySelector('[data-svp-ghost]'), hd = root.querySelector('[data-svp-head]');
  var pend = false;
  var tickSvp = function () {
    pend = false;
    var vh = window.innerHeight || 800;
    var r = root.getBoundingClientRect();
    if (r.top >= vh || r.bottom <= 0) return;
    var t = (vh - r.top) / (vh + r.height);
    if (gh) gh.style.transform = 'translate3d(' + ((150 - t * 420) * RM_AMP).toFixed(1) + 'px,' + ((t * 300 - 120) * RM_AMP).toFixed(1) + 'px,0) rotate(' + ((t * 10 - 5) * RM_AMP).toFixed(2) + 'deg) scale(' + (RM ? 1 : 0.86 + t * 0.34).toFixed(3) + ')';
    if (hd) hd.style.transform = 'translate3d(0,' + ((0.5 - t) * 44 * RM_AMP).toFixed(1) + 'px,0)';
    if (window.innerWidth > 900) {
      cards.forEach(function (c, i) { c.style.transform = 'translate3d(0,' + ((0.5 - t) * (30 + i * 22) * RM_AMP).toFixed(1) + 'px,0)'; });
    } else {
      cards.forEach(function (c) { c.style.transform = ''; });
    }
  };
  window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(tickSvp); } }, { passive: true });
  tickSvp();
}

function sizeRows() {
  var rows = $$('[data-size-row]');
  if (!rows.length) return;
  var mark = function (dim) {
    rows.forEach(function (r) { r.setAttribute('aria-pressed', r.getAttribute('data-dim') === dim ? 'true' : 'false'); });
  };
  rows.forEach(function (r) {
    r.addEventListener('click', function () {
      var dim = r.getAttribute('data-dim');
      mark(dim);
      try { document.dispatchEvent(new CustomEvent('proconex:set-size', { detail: { size: dim } })); } catch (e) { }
    });
  });
  document.addEventListener('proconex:size-changed', function (e) { if (e.detail && e.detail.size) mark(e.detail.size); });
}


function parallax() {
    var nodes = $$('[data-par]');
    var read = $('#readbar');
    var PMF = Math.max(0.42, Math.min(1, window.innerWidth / 1440));
    /* Mouvement réduit : parallaxe conservée à 30 % de son amplitude (RM_AMP), sans agrandissement. */
    var pending = false;
    var tick = function () {
      pending = false;
      var vh = window.innerHeight;

      if (read) {
        var h = document.documentElement.scrollHeight - vh;
        read.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0).toFixed(2) + '%';
      }
      nodes.forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        var t = (vh - r.top) / (vh + r.height) - 0.5;
        var amt = parseFloat(n.getAttribute(PMF < 1 && n.hasAttribute('data-par-m') ? 'data-par-m' : 'data-par')) || 40;
        var sc  = n.getAttribute('data-par-scale');
        n.style.transform = 'translate3d(0,' + (t * amt * PMF * RM_AMP).toFixed(1) + 'px,0)' +
          (sc && !RM ? ' scale(' + (1 + Math.abs(t) * parseFloat(sc)).toFixed(4) + ')' : '');
      });
    };
    var onScroll = function () { if (!pending) { pending = true; requestAnimationFrame(tick); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { PMF = Math.max(0.42, Math.min(1, window.innerWidth / 1440)); onScroll(); });
    /* Pas de boucle rAF permanente sur téléphone : les événements scroll/resize suffisent. */
    tick();
  }

  /* -------------------------------------------------------- hero : photos */
  function heroRotate() {
    var wrap = $('.hero__media');
    if (!wrap) return;
    var shots = $$('img,video', wrap);
    if (shots.length < 2) { if (shots[0]) shots[0].classList.add('is-on'); return; }
    var i = 0;
    shots[0].classList.add('is-on');
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 2200); };
    idle(function () {
      shots.forEach(function (s) {
        if (s.dataset && s.dataset.src) { s.src = s.dataset.src; if (s.dataset.srcset) s.srcset = s.dataset.srcset; s.removeAttribute('data-src'); s.removeAttribute('data-srcset'); }
      });
    });
    /* Rythme : la PREMIÈRE image reste ~5 s une fois le chargeur parti (le compte à rebours ne tourne jamais
       derrière lui), puis la cadence normale reprend. Mouvement réduit : deux fois plus lent. */
    var STEP = RM ? 12000 : 6000, FIRST = RM ? 9000 : 5000, timer = 0, started = false;
    var advance = function () {
      if (document.hidden) return;                /* onglet caché : on ne consomme pas d'étape */
      shots[i].classList.remove('is-on');
      i = (i + 1) % shots.length;
      shots[i].classList.add('is-on');
    };
    var begin = function () {
      if (started) return; started = true;        /* jamais deux minuteries */
      timer = setTimeout(function () { advance(); timer = setInterval(advance, STEP); }, FIRST);
    };
    var whenVisible = function () {
      if (document.documentElement.classList.contains('lo-done')) { begin(); return; }
      setTimeout(whenVisible, 120);               /* on attend la disparition réelle du chargeur */
    };
    whenVisible();
  }

  /* ------------------------------------------------------------ accordéons */
  function accordions() {
    $$('[data-acc]').forEach(function (root) {
      var items = $$('.acc__i', root);
      items.forEach(function (it, idx) {
        var q = $('.acc__q', it), a = $('.acc__a', it);
        if (!q || !a) return;
        var setOpen = function (v) {
          it.classList.toggle('is-open', v);
          q.setAttribute('aria-expanded', v ? 'true' : 'false');
          a.style.maxHeight = v ? (a.firstElementChild.offsetHeight + 8) + 'px' : '0px';
        };
        q.addEventListener('click', function () {
          var was = it.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var oa = $('.acc__a', o), oq = $('.acc__q', o);
            if (oa) oa.style.maxHeight = '0px';
            if (oq) oq.setAttribute('aria-expanded', 'false');
          });
          if (!was) setOpen(true);
        });
        if (idx === 0 && root.hasAttribute('data-acc-first')) setOpen(true);
      });
      // une réponse ouverte garde une hauteur max mesurée : on la remesure si la mise en page change
      var rt = 0;
      window.addEventListener('resize', function () {
        if (rt) return; rt = setTimeout(function () { rt = 0;
          items.forEach(function (it) { if (!it.classList.contains('is-open')) return; var a = $('.acc__a', it); if (a && a.firstElementChild) a.style.maxHeight = (a.firstElementChild.offsetHeight + 8) + 'px'; });
        }, 120);
      }, { passive: true });
    });
  }

  /* -------------------------------------------------------------- filtres */
  function filters() {
    $$('[data-filter-root]').forEach(function (root) {
      var chips = $$('[data-filter]', root);
      var cards = $$('[data-cat]', root);
      var empty = $('[data-empty]', root);
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var v = c.getAttribute('data-filter');
          chips.forEach(function (o) { o.classList.toggle('is-on', o === c); });
          var shown = 0;
          cards.forEach(function (card) {
            var ok = (v === '*') || card.getAttribute('data-cat') === v;
            card.hidden = !ok;
            if (ok) shown++;
          });
          if (empty) empty.hidden = shown > 0;
        });
      });
    });
  }

  /* ------------------------------------------------- fiche projet (modale) */
  function projectModal() {
    var modal = $('#project-modal');
    if (!modal) return;
    var box = $('.modal__box', modal);
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    var closeLbl = modal.getAttribute('data-close-label') || 'Fermer';
    var mLast = null;
    var close = function () { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (mLast && mLast.focus) mLast.focus(); };

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-project]');
      if (trigger) {
        var src = document.getElementById(trigger.getAttribute('data-project'));
        if (!src) return;
        mLast = trigger;
        box.innerHTML = '<button class="modal__x" type="button" data-close aria-label="' + closeLbl + '">&times;</button>' + src.innerHTML;
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        $$('[data-rv]', box).forEach(function (n) { n.classList.add('is-in'); });
        var xb = $('.modal__x', box); if (xb) xb.focus();
        return;
      }
      if (e.target.closest('[data-close]') || e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) { close(); return; }
      if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
      var f = $$('a[href],button,[tabindex]:not([tabindex="-1"])', box).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* -------------------------------------------------- onglets zones/régions */
  function zoneTabs() {
    var root = $('[data-zones]');
    if (!root) return;
    var tabs = $$('.zone__tab', root);
    var panes = $$('[data-zone-pane]', root);
    var ind = $('.zone__ind', root);
    var place = function (btn) {
      if (!ind || !btn) return;
      ind.style.width = btn.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
    };
    var list = tabs[0] && tabs[0].parentElement;
    if (list) list.setAttribute('role', 'tablist');
    tabs.forEach(function (t, i) {
      t.setAttribute('role', 'tab');
      t.setAttribute('id', 'zone-tab-' + i);
      t.setAttribute('aria-controls', 'zone-pane-' + i);
      t.setAttribute('aria-selected', t.classList.contains('is-on') ? 'true' : 'false');
      if (panes[i]) { panes[i].setAttribute('role', 'tabpanel'); panes[i].setAttribute('id', 'zone-pane-' + i); panes[i].setAttribute('aria-labelledby', 'zone-tab-' + i); }
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); n.click();
      });
      t.addEventListener('click', function () {
        tabs.forEach(function (o) { o.classList.toggle('is-on', o === t); o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        panes.forEach(function (p, j) {
          var on = j === i;
          p.hidden = !on;
          p.style.display = on ? 'flex' : 'none';
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        place(t);
      });
    });
    panes.forEach(function(p,j){
      var on = j === 0;
      p.hidden = !on;
      p.style.display = on ? 'flex' : 'none';
      p.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    place(tabs[0]);
    window.addEventListener('resize', function () { place($('.zone__tab.is-on', root) || tabs[0]); });
  }

  /* ---------------------------------------------------------- rail d'atelier */
  function railx() {
    $$('[data-railx]').forEach(function (el) {
      var bar = el.parentElement.querySelector('[data-railbar]');
      var upd = function () {
        if (!bar) return;
        var max = el.scrollWidth - el.clientWidth;
        var f = max > 4 ? el.scrollLeft / max : 0;
        bar.style.transform = 'scaleX(' + (0.14 + 0.86 * clamp(f, 0, 1)).toFixed(4) + ')';
      };
      el.addEventListener('scroll', upd, { passive: true });
      var down = null;
      el.addEventListener('mousedown', function (e) { down = { x: e.clientX, s: el.scrollLeft }; el.style.cursor = 'grabbing'; });
      window.addEventListener('mousemove', function (e) { if (down) el.scrollLeft = down.s - (e.clientX - down.x); });
      window.addEventListener('mouseup', function () { down = null; el.style.cursor = 'grab'; });
      upd();
    });
  }

  /* ------------------------------------------- comparateur kit vs clé en main */
  function kvk() {
    $$('.kvk').forEach(function (root) {
      $$('[data-kvk-pick]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          root.setAttribute('data-kvk', b.getAttribute('data-kvk-pick'));
          $$('[data-kvk-pick]', root).forEach(function (o) { o.classList.toggle('is-on', o === b); });
        });
      });
    });
  }

  /* ------------------------------------------------------- jeux de cartes */
  function decks() {
    $$('[data-deck]').forEach(function (root) {
      var cards = $$('figure', root);
      if (cards.length < 2) return;
      var n = cards.length;
      var step = function () {
        cards.forEach(function (c) {
          var p = (parseInt(c.getAttribute('data-pos'), 10) + n - 1) % n;
          c.setAttribute('data-pos', p);
        });
      };
      root.addEventListener('click', step);
      root.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); step(); } });
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) { if (x0 !== null && Math.abs(e.changedTouches[0].clientX - x0) > 40) step(); x0 = null; }, { passive: true });
    });
  }

  /* --------------------------------------------- iframes différées (vidéos) */
  function deferMedia() {
    var nodes = $$('[data-defer-src]');
    if (!nodes.length) return;
    var load = function (n) {
      if (!n.dataset.deferSrc) return;
      /* Vidéos : l'affiche reste visible jusqu'au chargement du lecteur (fondu), au plus tard après 2,5 s. */
      var slot = n.closest('[data-vid]');
      if (slot) { var live = function () { slot.classList.add('is-live'); }; n.addEventListener('load', live, { once: true }); setTimeout(live, 2500); }
      /* Variante étroite : certains embarqués (carte des zones) sont servis à un autre zoom sur téléphone,
         pour que l'échelle de projection tienne dans le cadre. */
      var narrow = window.matchMedia && window.matchMedia('(max-width:900px)').matches;
      n.src = (narrow && n.dataset.deferSrcM) ? n.dataset.deferSrcM : n.dataset.deferSrc;
      n.removeAttribute('data-defer-src'); n.removeAttribute('data-defer-src-m');
    };
    if (!('IntersectionObserver' in window)) { nodes.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '700px 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ----------------------------------------------------- curseur sur mesure */
  function cursor() {
    if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches || RM) return;
    document.documentElement.classList.add('has-cur'); // le CSS ne masque le curseur natif que sous cette classe
    var dot = document.createElement('div'); dot.className = 'cur-dot';
    var ring = document.createElement('div'); ring.className = 'cur-ring';
    document.body.appendChild(ring); document.body.appendChild(dot);
    var x = innerWidth / 2, y = innerHeight / 2, rx = x, ry = y, raf = 0;
    var draw = function () {
      rx += (x - rx) * 0.19; ry += (y - ry) * 0.19;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      if (Math.abs(x - rx) > 0.3 || Math.abs(y - ry) > 0.3) raf = requestAnimationFrame(draw); else raf = 0;
    };
    window.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      dot.style.opacity = ring.style.opacity = '1';
      if (!raf) raf = requestAnimationFrame(draw);
      var hot = !!e.target.closest('a,button,input,textarea,select,[role=button]');
      ring.classList.toggle('is-hot', hot);
      dot.classList.toggle('is-hot', hot);
    });
    document.addEventListener('mouseleave', function () { dot.style.opacity = ring.style.opacity = '0'; });
  }

  /* ---------------------------------------------------------- soumission */
  /* Récapitulatif : le visiteur relit sa demande dans SA langue, mais rien de ce qui part chez
     Proconex ne bouge. Les noms contact[…] et les valeurs des champs cachés restent français au
     caractère près ; seul l'affichage passe par une table nom technique → libellé traduit, servie
     par la page (window.PCX_RECAP). Dix-sept des vingt-deux libellés réutilisent la question déjà
     posée à l'écran, dont le texte français est identique au nom technique ; cinq ont leur propre
     clé pour que le français reste exactement ce qu'il est aujourd'hui.
     Table absente (autre page, script non chargé) : on retombe sur le nom technique, comme avant. */
  var RECAP_SKIP = ['Nom', 'Téléphone', 'email', 'body', 'Configuration', 'Lien de la configuration 3D'];
  var RECAP_SUFFIX = / \((Cabanon|Garage|Dalle|Kit|Autre)\)$/;
  /* Même précaution que pour le configurateur : « t » rend du HTML échappé et ces libellés sont
     écrits en textContent. On décode une fois, sur les cinq entités que « t » produit. */
  var RECAP_ENT = { "&#39;": "'", "&#x27;": "'", "&apos;": "'", "&quot;": '"', "&amp;": "&", "&lt;": "<", "&gt;": ">" };
  function recapDec(v) {
    return typeof v === 'string' && v.indexOf('&') >= 0
      ? v.replace(/&(?:#39|#x27|apos|quot|amp|lt|gt);/gi, function (m) { return RECAP_ENT[m.toLowerCase()] || m; })
      : v;
  }
  var recapCache = null;
  function recapDict() {
    if (recapCache) return recapCache;
    var src = window.PCX_RECAP;
    if (!src) return {};
    recapCache = {};
    ['labels', 'values'].forEach(function (g) {
      recapCache[g] = {};
      var o = src[g] || {};
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) recapCache[g][k] = recapDec(o[k]);
    });
    return recapCache;
  }
  function labelText(n) { return (n.textContent || '').replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim(); }
  function recapLabel(tech) {
    var base = tech.replace(RECAP_SUFFIX, '');
    return (recapDict().labels || {})[base] || base;
  }
  function recapValue(form, f, tech) {
    // Une valeur dont le libellé affiché diffère d'elle-même (les types de projet) passe par la
    // table. Sinon on prend le texte de la puce qui porte CETTE valeur — donc toujours la
    // traduction de ce qui sera réellement envoyé, jamais celle d'une puce simplement allumée.
    var named = (recapDict().values || {})[f.value];
    if (named) return named;
    var chips = $$('[data-pick]', form);
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-pick') === tech && (chips[i].getAttribute('data-value') || '') === f.value) return labelText(chips[i]);
    }
    return f.value;   // champ libre : les mots du visiteur
  }

  function quoteForm() {
    var form = $('[data-quote]');
    if (!form) return;
    var panes = $$('[data-step]', form);
    var bars = $$('.steps i, .qbars i', form);
    var heads = $$('[data-qhead]', form);
    var prev = $('[data-prev]', form), next = $('[data-next]', form), send = $('[data-send]', form);
    var cur = 0;

    var show = function (i) {
      cur = clamp(i, 0, panes.length - 1);
      panes.forEach(function (p, j) { p.hidden = j !== cur; });
      bars.forEach(function (b, j) { b.classList.toggle('is-on', j <= cur); });
      heads.forEach(function (h, j) { h.hidden = j !== cur; });
      if (prev) prev.disabled = cur === 0;
      if (next) next.hidden = cur === panes.length - 1;
      if (send) send.hidden = cur !== panes.length - 1;
      if (cur === panes.length - 1) {
        var rc = $('[data-recap] ul', form);
        if (rc) {
          rc.innerHTML = '';
          $$('input[type="hidden"][name^="contact["], input[type="text"][name^="contact["]', form).forEach(function (f) {
            if (f.disabled || !f.value) return;
            var tech = (f.name.match(/contact\[([^\]]+)\]/) || [])[1];
            if (!tech || RECAP_SKIP.indexOf(tech) > -1) return;
            var li = document.createElement('li');
            var t = document.createElement('span'); t.textContent = recapLabel(tech);
            var v = document.createElement('b'); v.textContent = recapValue(form, f, tech);
            li.appendChild(t); li.appendChild(v);
            rc.appendChild(li);
          });
          var recap = $('[data-recap]', form);
          if (recap) recap.hidden = rc.children.length === 0;
        }
      }
    };

    var sync = function () {
      var type = form.querySelector('[name="contact[Type de projet]"]');
      var v = type ? type.value : '';
      $$('[data-only]', form).forEach(function (n) {
        var want = n.getAttribute('data-only').split('|');
        var off = want.indexOf(v) === -1;
        n.hidden = off;
        /* Masquer ne suffisait pas : un champ caché reste soumis. Une demande de garage partait
           donc avec les réponses du cabanon, de la dalle et du kit, et le récapitulatif les
           montrait au client avant l'envoi. On désactive les champs du bloc écarté — un champ
           désactivé n'est ni soumis ni listé par le récapitulatif (voir show()) — plutôt que de
           les vider, pour que la réponse soit retrouvée intacte si le visiteur revient à ce type. */
        $$('[name^="contact["]', n).forEach(function (f) { f.disabled = off; });
      });
      var kitInput = form.querySelector('[name="contact[Type de kit]"]');
      var kitBox = form.querySelector('[data-kit-subtype]');
      if (v !== 'Kit prêt-à-assembler' && kitInput) {
        kitInput.value = '';
        $$('[data-pick="Type de kit"]', form).forEach(function (o) { o.classList.remove('is-on'); });
        if (kitBox) kitBox.classList.remove('has-error');
      }
    };

    form.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-pick]');
      if (!pick) return;
      e.preventDefault();
      var group = pick.getAttribute('data-pick');
      var input = form.querySelector('[name="contact[' + group + ']"]');
      $$('[data-pick="' + group + '"]', form).forEach(function (o) { o.classList.toggle('is-on', o === pick); });
      if (input) input.value = pick.getAttribute('data-value') || pick.textContent.trim();
      if (group === 'Type de kit') {
        var kb = form.querySelector('[data-kit-subtype]');
        if (kb) kb.classList.remove('has-error');
      }
      sync();
    });

    if (next) next.addEventListener('click', function (e) {
      e.preventDefault();
      if (cur === 0) {
        var type = form.querySelector('[name="contact[Type de projet]"]');
        var kit = form.querySelector('[name="contact[Type de kit]"]');
        if (type && type.value === 'Kit prêt-à-assembler' && kit && !kit.value) {
          var box = form.querySelector('[data-kit-subtype]');
          if (box) {
            box.classList.add('has-error');
            box.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
          }
          return;
        }
      }
      show(cur + 1);
    });
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(cur - 1); });

    show(0); sync();

    try {
      var saved = sessionStorage.getItem('proconex:config');
      if (!saved) {
        var q = new URLSearchParams(window.location.search);
        if (q.get('ptype')) saved = JSON.stringify({ type: q.get('ptype'), details: q.get('pdetails') || '' });
      }
      if (saved) {
        var txt = saved, shown = saved, typ = '';
        // txt part dans contact[Configuration] : français, c'est la donnée interne.
        // shown est relu par le client : sa langue. En français les deux sont identiques.
        try { var pj = JSON.parse(saved); if (pj && pj.details) { txt = pj.details; shown = pj.detailsUi || pj.details; typ = pj.type || ''; } } catch (e) { }
        var f = form.querySelector('[name="contact[Configuration]"]');
        if (f) f.value = txt;
        try {
          var pj2 = JSON.parse(saved);
          var lf = form.querySelector('[name="contact[Lien de la configuration 3D]"]');
          if (lf && pj2 && pj2.link) lf.value = pj2.link;
        } catch (e2) { }
        if (typ) {
          var tsel = form.querySelector('[name="contact[Type de projet]"]');
          if (tsel) tsel.value = typ;
          $$('[data-pick="Type de projet"]', form).forEach(function (o) {
            o.classList.toggle('is-on', (o.getAttribute('data-value') || o.textContent.trim()) === typ);
          });
        }
        if (typ) { sync(); show(1); }
        var echo = $('[data-config-echo]', form);
        if (echo && shown) { echo.hidden = false; echo.querySelector('span').textContent = shown; }
      }
    } catch (err) { }
  }

  function unlockPageScroll() {
    ['menu-open', 'no-scroll', 'locked'].forEach(function (c) {
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    });
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
  }
  window.addEventListener('pageshow', unlockPageScroll);

  /* --------------------------------------------- avant/après : mini-démo */
  function beforeAfterDemo() {
    if (RM) return;
    $$('.ba').forEach(function (root) {
      var input = $('input[type="range"]', root);
      if (!input || root.dataset.demoReady) return;
      root.dataset.demoReady = '1';
      /* Démo : un aller-retour droite → gauche → centre à chaque entrée dans l'écran, puis une reprise
         après un moment d'inactivité tant que le bloc reste visible. Toute interaction du client
         (pointeur, toucher, clavier, focus) arrête la démo pour de bon : elle ne se bat jamais avec lui. */
      var stopped = false, running = false, raf = 0, visible = false, idleTimer = 0, cycles = 0, MAX_IDLE_CYCLES = 3;
      var demoV = 50;
      function setV(v) { demoV = v; root.style.setProperty('--ba', v.toFixed(2) + '%'); input.value = Math.round(v); }
      function stop() { stopped = true; if (raf) cancelAnimationFrame(raf); raf = 0; if (idleTimer) clearTimeout(idleTimer); idleTimer = 0; }
      /* Sur téléphone, poser le doigt sur le bloc pour faire défiler la page déclenche pointerdown /
         touchstart : ce n'est PAS une interaction avec le curseur. On n'arrête donc la démo que sur une
         intention réelle : relâchement sans défilement (pointerup), glissement horizontal, valeur
         modifiée par le client (input/change hors geste de défilement), clavier. Un pointercancel ou un
         déplacement vertical dominant (le navigateur fait défiler la page) annule tout ; si le navigateur
         a quand même déplacé le curseur pendant ce défilement, la démo reprend sa valeur. */
      var pendingStop = false, gestureScroll = false, px = 0, py = 0;
      root.addEventListener('pointerdown', function (e) { pendingStop = true; gestureScroll = false; px = e.clientX; py = e.clientY; }, { passive: true });
      root.addEventListener('pointermove', function (e) {
        if (!pendingStop) return;
        var dx = Math.abs(e.clientX - px), dy = Math.abs(e.clientY - py);
        if (dy > 10 && dy > dx) { gestureScroll = true; pendingStop = false; }
        else if (dx > 6 && dx > dy) { stop(); pendingStop = false; } /* glissement horizontal = vraie manipulation */
      }, { passive: true });
      root.addEventListener('pointercancel', function () { pendingStop = false; gestureScroll = true; }, { passive: true });
      root.addEventListener('pointerup', function () { if (pendingStop) stop(); pendingStop = false; gestureScroll = false; }, { passive: true });
      root.addEventListener('lostpointercapture', function () { gestureScroll = false; }, { passive: true });
      function onValue() {
        if (stopped) return;
        if (gestureScroll && running) { setV(demoV); return; } /* valeur bougée par le défilement : on l'ignore */
        stop();
      }
      root.addEventListener('input', onValue);
      root.addEventListener('change', onValue);
      root.addEventListener('keydown', function (e) { if (e.key && /^Arrow|^Home$|^End$|^Page/.test(e.key)) stop(); });
      function armIdle() {
        if (stopped || !visible || cycles >= MAX_IDLE_CYCLES) return;
        if (idleTimer) clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { idleTimer = 0; if (!document.hidden) run(); }, 7000);
      }
      function run() {
        if (stopped || running || document.hidden) return;
        running = true; cycles++;
        var key = [{t:0,v:50},{t:.28,v:74},{t:.64,v:26},{t:1,v:50}], dur = 3200, t0 = performance.now();
        function frame(now) {
          if (stopped) return;
          var p = Math.min(1, (now - t0) / dur), a = key[0], b = key[key.length - 1];
          for (var i=1;i<key.length;i++) if (p <= key[i].t) { a=key[i-1]; b=key[i]; break; }
          var q = (p-a.t) / Math.max(.001,b.t-a.t); q = q*q*(3-2*q);
          setV(a.v + (b.v-a.v)*q);
          if (p < 1) raf = requestAnimationFrame(frame);
          else { raf = 0; running = false; setV(50); armIdle(); }
        }
        raf = requestAnimationFrame(frame);
      }
      function enter() { if (visible) return; visible = true; cycles = Math.min(cycles, MAX_IDLE_CYCLES - 1); setTimeout(run, 220); } // rejoue à chaque entrée dans l'écran
      function leave() { visible = false; if (idleTimer) { clearTimeout(idleTimer); idleTimer = 0; } }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) enter(); else leave(); }, { threshold:.45 });
        io.observe(root);
      }
      /* Filet indépendant de l'observateur (défilement rapide, onglet caché pendant le défilement, WebKit) :
         un contrôle cadencé au défilement détecte l'entrée du bloc à 45 % visible. */
      var bt = 0;
      function check() {
        bt = 0;
        var r = root.getBoundingClientRect(), vh = window.innerHeight || 800;
        var shown = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        if (shown / Math.max(1, r.height) >= 0.45) enter(); else if (shown <= 0) leave();
      }
      function ask() { if (!bt) bt = setTimeout(check, 90); }
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', ask);
      setTimeout(check, 400);
      // page ouverte dans un onglet en arrière-plan : la démo démarre quand l'onglet devient visible
      document.addEventListener('visibilitychange', function () { if (!document.hidden) { if (visible && !running) setTimeout(run, 220); else ask(); } });
    });
  }

  /* --------------------------------------------- FAB téléphone : évite toute zone critique */
  function fabGuard() {
    var fab = $('[data-r~="fabtel"]');
    if (!fab || !(window.matchMedia && window.matchMedia('(pointer:coarse)').matches)) return;
    var watched = $$([
      'form','.ftr','footer','.cta-block','.qbox','.quote-page','.contact-source',
      '.faq-section','.product-config','.product-sizes','.product-options',
      '.projects-section--deck','.home-promise','.service-steps','.kvk',
      '.seqp','.asm','.before-after-section'
    ].join(','));
    var visible = new Set();
    function sync(extra) {
      var keyboard = !!extra || document.documentElement.classList.contains('menu-open');
      fab.classList.toggle('is-hidden', keyboard || visible.size > 0);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });
        sync(false);
      }, { rootMargin:'-4% 0px -10% 0px', threshold:0 });
      watched.forEach(function (n) { io.observe(n); });
    }
    document.addEventListener('focusin', function(e){
      if (e.target && e.target.matches && e.target.matches('input,textarea,select,[contenteditable="true"]')) sync(true);
    });
    document.addEventListener('focusout', function(){ setTimeout(function(){ sync(false); }, 80); });
    if (window.visualViewport) {
      var baseH = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', function(){
        var keyboardOpen = window.visualViewport.height < baseH * 0.78;
        sync(keyboardOpen);
        if (!keyboardOpen) baseH = Math.max(baseH, window.visualViewport.height);
      }, { passive:true });
    }
    sync(false);
  }

  /* --------------------------------------------- médias de secours : jamais d’icône cassée */
  function mediaRescue() {
    /* Une image qui échoue n'est JAMAIS remplacée par une photo sans rapport : seul un repli
       explicitement configuré pour ce bloc (data-media-fallback) est utilisé ; sinon l'image est
       retirée proprement (pas d'icône cassée, pas de bloc noir), et son conteneur est marqué. */
    $$('img[data-media-fallback], img[data-media-hide]').forEach(function(img){
      if (img.dataset.rescueBound) return;
      img.dataset.rescueBound='1';
      function rescue(){
        var fb = img.getAttribute('data-media-fallback');
        if (img.dataset.rescued === '1') {
          img.hidden = true; if (img.parentElement) img.parentElement.classList.add('is-media-missing');
          return;
        }
        img.dataset.rescued='1';
        if (fb && fb !== img.currentSrc && fb !== img.src) { img.src = fb; return; }
        img.hidden = true; if (img.parentElement) img.parentElement.classList.add('is-media-missing');
      }
      img.addEventListener('error', rescue);
      /* A cached failure may have happened before boot/error binding. */
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) rescue();
    });
  }

  /* ------------------------------------------------------------------ boot */
  var PXOFF = (function () { try { var m = (location.search.match(/[?&]pxoff=([^&]*)/) || [])[1]; return m ? m.split(',') : []; } catch (e) { return []; } })();
  /* ------------------------------------------- avis : piste manipulable */
  function reviewsRail() {
    $$('.rev').forEach(function (rail) {
      var track = $('.rev__t', rail);
      if (!track || rail.dataset.railBound) return;
      rail.dataset.railBound = '1';

      /* Les deux mouvements coexistent :
         - défilement automatique lent et discret (22 px/s), en boucle sans saut visible : la piste
           contient deux fois les mêmes avis, on replie la position d'une demi-piste quand elle est
           franchie, ce qui est indétectable à l'œil ;
         - contrôle manuel complet (molette, trackpad, doigt, glisser à la souris) : pendant et après
           une manipulation la position reste exactement celle laissée par le visiteur, le défilement
           reprend depuis ce point après un court délai, jamais depuis le début. */
      track.style.animation = 'none';
      track.style.transform = 'none';
      rail.classList.add('is-manual');
      if (!rail.hasAttribute('tabindex')) rail.setAttribute('tabindex', '0');
      if (!rail.getAttribute('role')) rail.setAttribute('role', 'region');

      var SPEED = 22;                 /* px par seconde : lecture possible sans course */
      var RESUME = 2200;              /* reprise après la fin d'une manipulation */
      var stopped = RM;               /* mouvement réduit : aucun défilement automatique */
      var holdUntil = 0;              /* pause temporaire pendant l'interaction */
      var hovering = false;

      /* Période de la boucle = largeur d'UN jeu d'avis : la piste en contient deux, plus ses marges
         internes, qui ne font pas partie du motif répété. */
      var half = function () {
        var cs = getComputedStyle(track);
        return (track.scrollWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0)) / 2;
      };
      var wrap = function () {
        var h = half();
        if (h < 2) return;
        if (rail.scrollLeft >= h) rail.scrollLeft -= h;
        else if (rail.scrollLeft < 0) rail.scrollLeft += h;
      };

      var hold = function () { holdUntil = Date.now() + RESUME; };

      /* Lecture au survol : le mouvement s'arrête tant que la souris reste sur les avis.
         L'état est relu du navigateur (:hover) à chaque image plutôt que mémorisé sur
         pointerenter/pointerleave : quand le contenu défile sous un curseur immobile, les
         événements d'entrée arrivent sans l'événement de sortie correspondant et la piste
         restait en pause pour de bon. */
      var fine = !!(window.matchMedia && window.matchMedia('(pointer:fine)').matches);
      var isHovered = function () {
        if (!fine) return false;
        try { return rail.matches(':hover'); } catch (err) { return false; }
      };
      rail.addEventListener('focusin', function () { hovering = true; });
      rail.addEventListener('focusout', function () { hovering = false; });
      rail.addEventListener('wheel', hold, { passive: true });
      rail.addEventListener('touchstart', hold, { passive: true });
      rail.addEventListener('touchmove', hold, { passive: true });
      rail.addEventListener('touchend', hold, { passive: true });
      rail.addEventListener('keydown', hold);

      var down = false, startX = 0, startScroll = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) {
        hold();
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.pointerType === 'touch') return;      /* le doigt utilise le défilement natif du conteneur */
        down = true; moved = false;
        startX = e.clientX; startScroll = rail.scrollLeft;
        rail.classList.add('is-grabbing');
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        hold();
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          if (!moved) { moved = true; try { rail.setPointerCapture(e.pointerId); } catch (err) {} }
          rail.scrollLeft = startScroll - dx;       /* suit le curseur, gauche comme droite */
          wrap();
        }
      });
      var release = function (e) {
        if (!down) return;
        down = false;
        hold();
        rail.classList.remove('is-grabbing');
        if (e && e.pointerId != null) { try { rail.releasePointerCapture(e.pointerId); } catch (err) {} }
      };
      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);
      rail.addEventListener('lostpointercapture', release);
      /* Un clic de fin de glissement ne doit pas suivre un lien éventuel dans la carte. */
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      /* Avance : jamais quand l'onglet est caché, quand le visiteur tient la piste, la survole,
         ou a demandé l'arrêt. Le mouvement garde sa propre position en virgule flottante et la
         réécrit à chaque image : lire puis incrémenter scrollLeft se faisait rattraper par les
         arrondis du navigateur et la piste finissait par se figer. Dès que la position réelle
         s'écarte de la nôtre (le visiteur a fait glisser, la molette a servi), on repart de la
         sienne — jamais du début. */
      var prev = 0, pos = null;
      var step = function (now) {
        var dt = prev ? Math.min(0.1, (now - prev) / 1000) : 0;
        prev = now;
        var idle = !stopped && !down && !hovering && !isHovered() && Date.now() > holdUntil && !document.hidden;
        if (idle && dt > 0 && rail.scrollWidth > rail.clientWidth + 4) {
          if (pos === null || Math.abs(rail.scrollLeft - pos) > 2) pos = rail.scrollLeft;
          pos += SPEED * dt;
          var h = half();
          if (h > 2) { if (pos >= h) pos -= h; else if (pos < 0) pos += h; }
          rail.scrollLeft = pos;
        } else {
          pos = null;   /* pendant une pause, la position de référence est celle du visiteur */
        }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      document.addEventListener('visibilitychange', function () { prev = 0; });
    });
  }

  /* ------------------------------------------------- mouvement réduit */
  function reducedMotion() {
    if (!RM) return;
    /* Témoignages : la CSS remplace le défilement automatique par une piste défilable ; on la rend
       atteignable au clavier (région nommée, focalisable) pour que chaque avis reste consultable. */
    $$('.rev').forEach(function (rail) {
      if (!rail.hasAttribute('tabindex')) rail.setAttribute('tabindex', '0');
      if (!rail.getAttribute('role')) rail.setAttribute('role', 'region');
    });
  }

  function safeInit(name, code, fn) {
    if (PXOFF.indexOf(code) > -1) { if (window.console) console.log('[Proconex] ' + name + ' désactivé (pxoff)'); return; }
    try { fn(); } catch (err) { if (window.console) console.error('[Proconex] ' + name + ' failed', err); }
  }
  function boot() {
    unlockPageScroll();
    safeInit('loader', 'ldr', loader);
    setTimeout(heroGo, 3000); // filet : jamais un hero figé si le chargeur n'a pas pu signaler sa fin
    safeInit('header', 'hdr', header);
    safeInit('reveal', 'rv', reveal);
    safeInit('counters', 'cnt', counters);
    safeInit('parallax', 'par', parallax);
    safeInit('heroScroll', 'hsc', heroScroll); safeInit('magnetic', 'mag', magnetic); safeInit('svPromise', 'svp', svPromise); safeInit('sizeRows', 'szr', sizeRows);
    safeInit('accordions', 'acc', accordions);
    safeInit('filters', 'flt', filters);
    safeInit('projectModal', 'mod', projectModal);
    safeInit('zoneTabs', 'zon', zoneTabs);
    safeInit('cursor', 'cur', cursor);
    safeInit('quoteForm', 'frm', quoteForm);
    safeInit('deferMedia', 'vid', deferMedia);
    safeInit('beforeAfterDemo', 'bad', beforeAfterDemo);
    safeInit('fabGuard', 'fab', fabGuard);
    safeInit('mediaRescue', 'med', mediaRescue);
    safeInit('decks', 'car', decks);
    safeInit('kvk', 'ba', kvk);
    safeInit('railx', 'rail', railx);
    safeInit('reducedMotion', 'rmo', reducedMotion);
    safeInit('reviewsRail', 'rvp', reviewsRail);
    safeInit('heroRotate', 'hro', heroRotate);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
